<template>
  <v-toolbar :clipped-left="$L.cfg.clipped" :color="dark ? 'grey darken-4': toolbarColor" app  :dark="darkToolbar"
             flat>
    <!--<v-toolbar-side-icon @click="mainNavDrawer = !mainNavDrawer" v-show="!isWxLogin"></v-toolbar-side-icon>-->
    <v-toolbar-side-icon @click="mainNavDrawer = !mainNavDrawer"></v-toolbar-side-icon>
    <v-toolbar-title >
      <v-flex style="min-width: 1000px" layout align-center>
        <main-breadcrumbs v-if="!$L.cfg.clipped"></main-breadcrumbs>
        <slot v-else name="toolbar-title"></slot>
        <!--<v-icon small>mdi-home</v-icon>-->
        <!--<span class="px-2 body-2">首页</span>-->
      </v-flex>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip bottom class="hidden-sm-and-down" v-show="!isWxLogin">
      <v-btn @click="toggleFullScreen" icon slot="activator">
        <v-icon>mdi-fullscreen</v-icon>
      </v-btn>
      <span>全屏</span>
    </v-tooltip>
    <!--<color-menu>-->
    <v-tooltip bottom v-show="!isWxLogin">
      <span>切换主题</span>
      <v-btn @click="dark = !dark" icon slot="activator">
        <v-icon>mdi-invert-colors</v-icon>
      </v-btn>
    </v-tooltip>
    <!--</color-menu>-->
    <slot name="toolbar-items" ></slot>
  </v-toolbar>
</template>

<script>
import {createHelpers} from 'vuex-map-fields'
import MainBreadcrumbs from '../LBreadcrumbs/mainBreadcrumbs'

const {mapFields} = createHelpers({
  getterType: '$L/getField',
  mutationType: '$L/updateField',
})
export default {
  name: 'LToolbar',
  components: {MainBreadcrumbs},
  data: () => ({
    full_: false,
  }),
  computed: {
    isWxLogin () {
      return !(sessionStorage.getItem('isWxLogin') === null)
    },
    darkToolbar () {
      return this.$L.cfg.darkToolbar
    },
    toolbarColor () {
      return this.$L.cfg.toolbarColor || 'white'
    },
    fullScreen: {
      get () {
        return this.full_
      },
      set (val) {
        if (val) {
          this.inFullScreen()
        }
        else {
          this.exitFullscreen()
        }
        this.full_ = val
      },
    },
    ...mapFields([
      'dark',
      'mainNavDrawer',
      'bcItems',
    ]),
  },
  methods: {
    toggleFullScreen () {
      if (!document.fullscreenElement) {
        this.inFullScreen()
      }
      else {
        if (document.exitFullscreen) {
          this.exitFullscreen()
        }
      }
    },
    inFullScreen () {
      let elem = document.documentElement
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      }
      else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen()
      }
      else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen()
      }
      else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen()
      }
    },
    exitFullscreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
      else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen()
      }
      else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen()
      }
      else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen()
      }
    },
  },
}
</script>

<style scoped>
  .l-avatar {
    width: 36px;
    height: 36px;
    border-radius: 36px;
    line-height: 36px;
    border: 1px solid;
    font-size: 24px;
  }
</style>
